import { ClerkLoaded, ClerkLoading, RedirectToSignIn, Show } from '@clerk/react-router';
import type { ReactNode } from 'react';
import { LoadingBlockFullScreen } from './loading/loading-block-full-screen.tsx';

type AuthGuardProps = {
    children: ReactNode;
};

export const AuthGuard = ({ children }: AuthGuardProps) => {
    return (
        <>
            <ClerkLoading>
                <LoadingBlockFullScreen />
            </ClerkLoading>
            <ClerkLoaded>
                <Show when="signed-in">{children}</Show>
                <Show when="signed-out">
                    <RedirectToSignIn />
                </Show>
            </ClerkLoaded>
        </>
    );
};
